import { useEffect, useState } from "react"

const useCheckAnyElementFocused = (): Boolean => {
    const [isInputFocused, setIsInputFocused] = useState(false)

    useEffect(() => {
            const handleFocusIn = (event: any) => {
               if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                    setIsInputFocused(true)
                }
            }
    
            const handleFocusOut = (event: any) => {
                if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                    setIsInputFocused(false)
                }
            }
    
            window.addEventListener('focusin', handleFocusIn)
            window.addEventListener('focusout', handleFocusOut)
    
            return () => {
                window.removeEventListener('focusin', handleFocusIn)
                window.removeEventListener('focusout', handleFocusOut)
            }
        }, [])

    return isInputFocused
}

export default useCheckAnyElementFocused